import { revalidateTag } from "next/cache";
function handleSitePublished(_payload) {
  revalidateTag(MAKESWIFT_CACHE_TAG);
  return { body: { success: true }, status: 200 };
}
const MAKESWIFT_CACHE_TAG = "@@makeswift";
export {
  MAKESWIFT_CACHE_TAG,
  handleSitePublished
};
//# sourceMappingURL=site-published.js.map